//Mapa crack e mapa fronteira
const colorMapping = {
	governanca: 'var(--governanca)',
	cidadesHistoricas: 'var(--cidadesHistoricas)',
	patrimonioMundial: 'var(--patrimonioMundial)',
	semEventos: 'var(--amarelo)'
};


const normalizeResponse = (response) => {
	const normalized = response.toLowerCase().trim();
	switch (normalized) {
			case 'governança para o turismo':
			case 'governanca':
					return 'governanca';
			case 'cidades historicas': 
					return 'cidadesHistoricas';
			case 'patrimomio mundial':
					return 'patrimonioMundial';
			case '':
					return 'semEventos';
			default:
					return 'semEventos'; 
	}
};

export const getColorByResponse = (response) => {
	const normalizedResponse = normalizeResponse(response); 
	return colorMapping[normalizedResponse] || colorMapping.semEventos; 
};

export const getColorMapping = () => colorMapping; 
